import React from 'react'
import styled, { keyframes } from 'styled-components'
import SpinnerImg from '../../images/spinner.svg'

type Props = {
  isShowSpinner: boolean
  children: React.ReactNode
}

export const SpinnerTemplate: React.FC<Props> = props => {
  return (
    <>
      {props.isShowSpinner && <AnimationSpinner src={SpinnerImg} />}
      {props.children}
    </>
  )
}

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

const AnimationSpinner = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 80px;
  height: 80px;
  z-index: 999;
  animation: ${rotate} 0.6s linear infinite;
`
